class cardSlider extends HTMLElement {
  constructor() {
    super();

    this.arrowsContainer = this.querySelector(".swiper-button-container");
    this.previousArrow = this.querySelector(".swiper-button-prev");
    this.nextArrow = this.querySelector(".swiper-button-next");
    this.cardsContainer = this.querySelector(".cards");
    this.cardSpacing = this.dataset.spacing;

    if (this.previousArrow) {
      this.previousArrow.addEventListener(
        "click",
        this.handlePrevClick.bind(this)
      );
    }

    if (this.nextArrow) {
      this.nextArrow.addEventListener("click", this.handleNextClick.bind(this));
    }

    this.initVideoControls();
  }

  handlePrevClick() {
    this.scrollCards("prev");
  }

  handleNextClick() {
    this.scrollCards("next");
  }

  scrollCards(direction) {
    let cardWidth = this.querySelector(".card").offsetWidth;
    let cardSpacing = this.cardSpacing;
    let scrollValue = cardWidth + cardSpacing;

    if (direction === "prev") {
      this.cardsContainer.scrollBy({
        left: -scrollValue,
        behavior: "smooth",
      });
    } else if (direction === "next") {
      this.cardsContainer.scrollBy({
        left: scrollValue,
        behavior: "smooth",
      });
    }
  }

  initVideoControls() {
    const videoContainers = this.querySelectorAll(".card-video--container");

    videoContainers.forEach((container) => {
      const video = container.querySelector("video");
      const playPauseBtn = container.querySelector(".video-play-pause-btn");

      if (video && playPauseBtn) {
        container.style.cursor = "pointer";
        container.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggleVideoPlayback(video, playPauseBtn);
        });
      }
    });
  }

  toggleVideoPlayback(video, button) {
    if (video.paused) {
      video.play();
      button.classList.remove("is-paused");
    } else {
      video.pause();
      button.classList.add("is-paused");
    }
  }
}

customElements.define("card-slider", cardSlider);
class ProductCrossells extends HTMLElement {
  constructor() {
    super();
    this.initSlider();
  }

  initSlider() {
    const slidesPerViewMobile = Number(this.dataset.slidesPerViewMobile);
    const slidesPerViewDesktop = Number(this.dataset.slidesPerViewDesktop);
    const swiper = new Swiper(this, {
      // Optional parameters
      direction: "horizontal",
      loop: false,
      slidesPerView: slidesPerViewMobile,
      spaceBetween: 15,
      breakpoints: {
        1024: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: 15,
          centerInsufficientSlides: true,
        },
      },
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar"),
        draggable: true
      },
    });
  }
}
customElements.define("product-crossells", ProductCrossells);
class ProductCrossell extends HTMLElement {
  constructor() {
    super();
    this.template = this.querySelector("template").content;
    this.options = Array.from(this.template.querySelectorAll("option"));
    this.selects = this.querySelectorAll("select");
    this.image = this.querySelector(".product-crossell__image");
    this.addToCardButton = this.querySelector(".product-crossell__add-to-cart");
    this.toggleDescription = this.querySelector('.product-crossell__trigger-info');
    this.description = this.querySelector('.product-crossell__info');
  }

  connectedCallback() {
    this.selects.forEach((select) => {
      select.addEventListener("change", this.handleSelectChange.bind(this));
    });
    this.addToCardButton.addEventListener(
      "click",
      this.handleAddToCart.bind(this)
    );
    this?.toggleDescription?.addEventListener('click', this.handleToggleDescription.bind(this));
    this?.description?.addEventListener('click', this.handleToggleDescription.bind(this));

    // remove the active class on the description when the user clicks outside of the description
    document.addEventListener('click', (event) => {
      if (!this.description?.contains(event.target) && !this.toggleDescription?.contains(event.target)) {
        this.description?.classList.remove('product-crossell__info--active');
      }
    });
  }


  handleSelectChange(event) {
    const selectedOptions = this.getSelectedOptions();
    this.updateVariantId(selectedOptions);
    this.updateVariantImage(selectedOptions);
  }

  getSelectedOptions() {
    const selectedOptions = [];
    this.selects.forEach((select) => {
      selectedOptions.push(select.value);
    });
    return selectedOptions;
  }

  updateVariantId(selectedOptions) {
    const variant = this.getVariantId(selectedOptions);
    const variantId = variant.value;
    this.addToCardButton.dataset.variantId = variantId;
    this.updateButtonState(variant.dataset.available);
  }

  updateButtonState(availablity) {
    if (availablity == "true") {
      this.addToCardButton.disabled = false;
      this.addToCardButton.innerText = theme.strings.addToCart;
    } else {
      this.addToCardButton.disabled = true;
      this.addToCardButton.innerText = theme.strings.soldOut;
    }
  }

  updateVariantImage(selectedOptions) {
    const variant = this.getVariantId(selectedOptions);
    const variantImage = variant.dataset.image;
    this.image.src = variantImage;
  }

  getVariantId(selectedOptions) {
    const variant = this.options.find((option) => {
      const optionValues = option.dataset.option;
      return selectedOptions.every((selectedOption) =>
        optionValues.includes(selectedOption)
      );
    });
    return variant;
  }

  handleAddToCart(event) {
    let formData = {
      items: [
        {
          id: event.target.dataset.variantId,
          quantity: 1,
        },
      ],
    };
    var product = null;
    this.addToCardButton.classList.add("btn--loading");
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        product = data;
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: this.addToCardButton,
            },
          })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        this.addToCardButton.classList.remove("btn--loading");
      });
  }
  handleToggleDescription() {
    document.querySelectorAll('.product-crossell__info').forEach((description) => {
      if (description !== this.description) {
        description.classList.remove('product-crossell__info--active');
      }
    });
    this.description.classList.toggle('product-crossell__info--active');
  }
}
customElements.define("product-crossell", ProductCrossell);
